import type { SVGProps } from 'react';

export const SvgGuideIllustFamily = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={257} height={193} viewBox="0 0 257 193" fill="none" {...props}>
    <g
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.81}
      clipPath="url(#page-top__image--example_svg__a)">
      <path
        fill="#FADDD6"
        d="M133.072 80.027v.762c0 1.893 2.997 3.43 6.697 3.43s6.696-1.537 6.696-3.43v-.762q0 .195-.042.38c-.368 1.716-3.207 3.05-6.655 3.05s-6.286-1.335-6.656-3.05a1.8 1.8 0 0 1-.041-.38z"
      />
      <path
        fill="#DE6878"
        d="M133.071 80.03q0 .192.041.38c.368 1.715 3.207 3.049 6.656 3.049s6.286-1.335 6.655-3.05q.042-.186.042-.38c0-1.896-2.998-3.431-6.696-3.431s-6.697 1.535-6.697 3.431z"
      />
      <path d="M146.465 80.91v-.12M146.465 80.027v-.171" />
      <path
        fill="#FF0019"
        d="M140.932 19.578v59.978h-.005c-.041.384-.525.689-1.115.689-.591 0-1.074-.304-1.115-.69h-.005V19.579z"
      />
      <path fill="#FADDD6" d="M139.18 19.578v60.535c-.273-.124-.458-.326-.483-.557h-.005V19.578z" />
      <path
        fill="#F5CE2F"
        d="M139.812 11.288c-5.546 0-10.042-2.303-10.042-5.144 0-2.84 4.496-5.144 10.042-5.144s10.042 2.303 10.042 5.144-4.496 5.144-10.042 5.144"
      />
      <path
        fill="#F5CE2F"
        d="M129.772 6.145V19.75c0 2.842 4.495 5.145 10.041 5.145s10.041-2.303 10.041-5.145V6.145c0 2.84-4.496 5.144-10.042 5.144S129.77 8.984 129.77 6.145z"
      />
      <path
        fill="#FADDD6"
        d="M139.812 24.9q.568 0 1.12-.033v.231c-.658.945-1.872.882-2.239.861v-1.092q.552.032 1.12.033z"
      />
    </g>
    <path
      fill="url(#page-top__image--example_svg__b)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m90.55 42.678 6.185-3.57c.663-.383 1.262-.417 1.695-.166l35.484 20.621c-.433-.252-1.034-.215-1.695.166l-6.185 3.572c-1.316.76-2.379 2.6-2.375 4.113l.06 23.138c.002.751.267 1.28.694 1.527L88.929 71.46c-.427-.25-.692-.778-.695-1.528l-.06-23.138c-.004-1.513 1.059-3.354 2.375-4.113z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M126.033 63.3c-1.316.76-2.379 2.6-2.375 4.113l.06 23.138c.004 1.512 1.074 2.122 2.391 1.362l6.184-3.57c1.317-.76 2.38-2.603 2.376-4.114l-.06-23.138c-.004-1.512-1.074-2.122-2.391-1.362l-6.185 3.572z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M61.298 53.644a6 6 0 0 1 .169-.786 5.77 5.77 0 0 1 2.663-3.405l19.652-11.346a1.65 1.65 0 0 1 1.635-.015l9.355 4.46-7.972 4.272 1.183 16.508-16.531 9.545.668 9.315-9.22-4.376-1.643-22.946a5.8 5.8 0 0 1 .043-1.225z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m72.112 82.195 25.083-14.482-1.713-23.906a1.662 1.662 0 0 0-2.489-1.32L73.341 53.832a5.78 5.78 0 0 0-2.875 5.417l1.643 22.946z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m121.91 89.7-.024-8.179-.019.011v-7.114l-12.711.168-9.623-5.547a5.9 5.9 0 0 0-5.891 0l-7.665 4.426-13.316.177v8.141c-.011.402.18.81.578 1.04l21.757 12.551c.57.329 1.181.556 1.807.68l.024 8.128L121.91 89.7z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m100.894 87.199 20.404-11.78c.77-.445.77-1.559 0-2.004L99.541 60.863a5.89 5.89 0 0 0-5.891 0l-20.404 11.78a1.157 1.157 0 0 0 0 2.004l21.756 12.552a5.9 5.9 0 0 0 5.892 0M37.064 68.003a6 6 0 0 1 .168-.786 5.77 5.77 0 0 1 2.664-3.405l19.652-11.346a1.65 1.65 0 0 1 1.635-.015l9.354 4.46-7.97 4.273 1.182 16.508-16.532 9.545.668 9.314-9.22-4.376-1.643-22.946a5.8 5.8 0 0 1 .043-1.225z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m47.887 96.554 25.084-14.482-1.713-23.906a1.662 1.662 0 0 0-2.49-1.32L49.116 68.193a5.78 5.78 0 0 0-2.875 5.417l1.644 22.946z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m97.676 104.06-.024-8.18-.02.012v-7.114l-12.71.168-9.623-5.548a5.9 5.9 0 0 0-5.892 0l-7.665 4.426-13.316.177v8.141c-.01.403.181.81.58 1.04l21.755 12.552c.57.328 1.182.555 1.808.679l.023 8.129 25.085-14.482z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m76.652 101.558 20.403-11.78c.771-.445.771-1.558 0-2.003L75.3 75.222a5.89 5.89 0 0 0-5.891 0l-20.404 11.78a1.157 1.157 0 0 0 0 2.004l21.756 12.552a5.89 5.89 0 0 0 5.891 0M11.896 82.362a6 6 0 0 1 .168-.786 5.77 5.77 0 0 1 2.664-3.404L34.38 66.825a1.65 1.65 0 0 1 1.635-.015l9.355 4.459-7.972 4.273 1.183 16.508-16.532 9.545.668 9.314-9.22-4.376-1.643-22.946a5.8 5.8 0 0 1 .044-1.224z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m22.72 110.914 25.083-14.482-1.713-23.906a1.662 1.662 0 0 0-2.49-1.32L23.948 82.551a5.78 5.78 0 0 0-2.875 5.417l1.643 22.946z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m72.508 118.419-.024-8.179-.02.011v-7.114l-12.71.168-9.623-5.547a5.9 5.9 0 0 0-5.892 0l-7.665 4.426-13.316.177v8.141c-.01.402.181.81.58 1.039l21.755 12.552c.57.329 1.182.555 1.808.679l.023 8.129 25.085-14.482z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m51.484 115.917 20.403-11.779c.771-.446.771-1.559 0-2.004L50.131 89.582a5.9 5.9 0 0 0-5.891 0l-20.404 11.78a1.157 1.157 0 0 0 0 2.003l21.756 12.552a5.89 5.89 0 0 0 5.892 0"
    />
    <path
      fill="#FF0019"
      d="M71.46 129.114c1.939 1.119 1.948 2.933.023 4.052-1.926 1.12-5.06 1.12-6.997 0l-4.764-2.751c-1.939-1.119-1.948-2.933-.023-4.052s5.06-1.119 6.997 0zM61.907 134.34c1.939 1.12 1.948 2.934.023 4.053s-5.06 1.119-6.997 0l-4.764-2.751c-1.938-1.119-1.948-2.933-.022-4.053 1.925-1.119 5.059-1.119 6.996 0z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M49.275 106.191c-.73 12.787 1.105 25.933 1.105 25.933 1.08 1.275 3.493 1.778 5.39.298l1.306-28.646h2.11l.635 23.635c1.677 1.391 3.486 1.391 5.094-.016 0 0 .506-4.026 1.708-19.135l-5.597-4.655c-7.483 2.473-4.344 5.267-11.754 2.585z"
    />
    <path
      fill="#fff"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M56.753 96.77s-8.411 1.103-13.337 1.593l-5.515 4.623c-1.451 3.936 8.302 9.908 8.302 9.908v7.763c4.994 4.488 23.688-4.179 23.887-6.768.116-1.512-.797-7.166-1.99-9.556-2.226-4.45-11.347-7.564-11.347-7.564z"
    />
    <path
      fill="#DE6878"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M52.13 69.24c-1.404-1.275-3.138-.568-3.138-.568l-9.814 2.617c-3.285 2.052-6.469 6.638-5.888 10.468.336 2.215 3.925 15.212 3.925 15.212s-.52 5.872-.072 5.564c6.706 3.272 18.092 3.454 22.284-4.493l-1.686-18.89s-.465-8.003-5.61-9.91"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M52.257 107.927a3.842 3.842 0 1 0 0-7.684 3.842 3.842 0 0 0 0 7.684"
    />
    <path fill="#DE6878" d="m44.07 88.64 8.422 11.287-4.395 4.542-11.61-10.823" />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m44.07 88.64 8.422 11.287-4.395 4.542-11.61-10.823"
    />
    <path
      fill="#FF0019"
      d="M44.263 52.763s-1.757-.42-3.397.11c-1.595.518-6.206 2.644-6.294 6.737-.07 3.195-1.96 8.632-3.845 10.59 0 0 6.673 3.918 14.87 3.7s10.107-14.488 10.107-14.488-2.584-5.84-6.212-6.783-5.23.134-5.23.134"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M46.148 73.08a9.536 9.536 0 1 0 0-19.072 9.536 9.536 0 1 0 0 19.072"
    />
    <path
      fill="#FF0019"
      d="M45.152 65.36a1.48 1.48 0 1 0 0-2.962 1.48 1.48 0 0 0 0 2.961M52.459 62.707a1.48 1.48 0 1 1-2.961 0 1.48 1.48 0 0 1 2.96 0M43.58 54.212c3.17-.91 5.56-.062 6.818.308-.328 5.196-8.681 8.91-13.078 9.608-.218-.1-.883.103-1.161.004-.309-3.966 2.141-8.496 7.422-9.922z"
    />
    <path
      fill="#FF0019"
      d="M53.013 56.745c1.443 1.292 1.766 2.745 1.974 3.486-2.686 1.46-7.14-1.534-8.86-3.503-.019-.14-.328-.406-.365-.575 1.876-1.392 4.893-1.588 7.25.592"
    />
    <path
      fill="url(#page-top__image--example_svg__c)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m4.375 91.79 6.185-3.573c.662-.382 1.262-.417 1.695-.165l35.484 20.621c-.433-.252-1.034-.216-1.695.165l-6.185 3.571c-1.316.759-2.38 2.6-2.375 4.113l.06 23.138c.001.751.267 1.28.694 1.527l-35.484-20.62c-.427-.25-.693-.778-.694-1.528L2 95.901c-.004-1.513 1.059-3.354 2.375-4.113z"
    />
    <path
      fill="#EC756E"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M39.86 112.41c-1.317.76-2.38 2.601-2.376 4.113l.06 23.138c.004 1.513 1.074 2.122 2.39 1.363l6.186-3.572c1.316-.76 2.379-2.601 2.375-4.113l-.06-23.138c-.004-1.513-1.074-2.122-2.39-1.362z"
    />
    <path
      fill="#FF0019"
      d="M130.958 101.086c1.939 1.12 1.948 2.934.023 4.053s-5.059 1.119-6.997 0l-4.764-2.751c-1.938-1.119-1.948-2.933-.023-4.052 1.926-1.12 5.059-1.12 6.997 0zM121.126 105.973c1.939 1.119 1.948 2.933.023 4.053-1.926 1.119-5.059 1.119-6.997 0l-4.764-2.751c-1.938-1.12-1.948-2.933-.023-4.053 1.926-1.119 5.059-1.119 6.997 0z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M108.494 78.163c-.73 12.788 1.105 25.934 1.105 25.934 1.08 1.275 3.493 1.778 5.39.297l1.306-28.645h2.11l.635 23.634c1.677 1.392 3.486 1.392 5.094-.015 0 0 .506-4.026 1.708-19.135l-5.597-4.655c-7.483 2.473-4.345 5.267-11.754 2.584z"
    />
    <path
      fill="#D9D9D9"
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M104.334 84.557C94.998 79.53 93.861 73.785 94.46 71.54l23.787-2.244c2.992 1.645 8.359 4.04 8.976 8.976.449 3.59-.449 14.96-.449 20.197 0 0-2.136 1.329-4.039 1.795-2.043.5-5.386 0-5.386 0v-18.85l-1.346 20.645s-.898.898-4.937.898-4.937-.898-4.937-.898z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M128.899 13.748c-3.1-.93-3.084 4.769-5.833 3.062-1.076-.667-2.512-.253-2.512-.253s-1.001.444-1.197 1.891 1.136 2.99 1.765 4.309l-10.195 15.727 8.386 5.003c.691.411 5.474-10.586 5.869-11.716.846-2.42 1.514-4.908 2.504-7.277.798-1.913 3.162-3.782 3.401-5.932.292-2.625-.73-4.376-2.188-4.813zM76.85 26.544c-.838-1.195-2.207-2.497-3.244-1.469-.899.892-.356 1.668-1.004 2.756-1.659 2.78-4.84-2.898-7.373-1.633-2.53 1.266-.723 4.568.116 5.523 1.027 1.17 2.31 2.124 4.143 2.992 3.21 1.519 4.603 1.495 4.603 1.495 6.2 6.17 10.87 8.582 18.536 12.794l2.502-7.485-17.393-10.88c-.047-1.46-.044-2.899-.884-4.094z"
    />
    <path
      fill="#B7B7B8"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M119.639 23.434s-14.073 21.937-18.637 19.224L79.435 30.9c-.248 1.535-3.644 6.122-5.232 6.748L94.315 53.64l-.736 19.422c6.463 4.711 18.281 4.983 24.41-3.161l.141-21.393 9.382-20.05s-2.889-3.302-7.873-5.023z"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M104.025 44.267c-5.348 0-9.683-4.335-9.683-9.682s4.335-9.683 9.683-9.683 9.682 4.335 9.682 9.683-4.335 9.682-9.682 9.682"
    />
    <path
      fill="#FF0019"
      d="M109.861 23.834c-3.347-2.037-6.113-.534-6.113-.534s-2.592-1.452-5.675-.097c-3.083 1.356-4.34 3.466-5.094 5.676-.728 2.134.035 6.12.035 6.12l3.84-1.984 2.518-3.903 14.043 2.073s-.304-5.375-3.552-7.352zM103.013 36.424a1.503 1.503 0 1 1-.001-3.006 1.503 1.503 0 0 1 .001 3.006M108.931 35.237a1.503 1.503 0 1 1-.001-3.007 1.503 1.503 0 0 1 .001 3.007M110.146 119.902c1.604.91 1.612 2.386.02 3.295-1.593.91-4.184.91-5.787 0l-3.941-2.236c-1.603-.91-1.611-2.385-.019-3.294s4.184-.91 5.787 0zM102.246 124.16c1.603.91 1.612 2.386.019 3.294-1.592.91-4.184.91-5.787 0l-3.94-2.235c-1.603-.91-1.611-2.385-.02-3.294 1.593-.91 4.185-.91 5.788 0z"
    />
    <path
      fill="#fff"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M91.722 94.36c-.353 10.405.281 27.772.281 27.772 2.34 2.435 5.603 1.52 7.04.098l1.615-23.054-.573 19.421c1.922 1.307 4.178 1.512 6.099-.09 0 0 .673-10.555 1.359-22.854l-.977-4.61c-5.846 2.13-8.967 5.381-14.844 3.32z"
    />
    <path
      fill="#F5CE2F"
      d="m108.437 82.494.338 14.126c-3.46 4.614-12.379 5.977-17.841 3.156-.379.239.541-9.884.541-9.884s-1.915 1.428-2.012-.909c-.176-4.207.165-10.519 3.445-12.888l9.578-5.525"
    />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m108.437 82.494.338 14.126c-3.46 4.614-12.379 5.977-17.841 3.156-.379.239.541-9.884.541-9.884s-1.915 1.428-2.012-.909c-.176-4.207.165-10.519 3.445-12.888l9.578-5.525"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M85.519 102.475c1.755 0 3.178-1.399 3.178-3.124s-1.423-3.124-3.178-3.124c-1.756 0-3.18 1.398-3.18 3.124 0 1.725 1.424 3.124 3.18 3.124"
    />
    <path fill="#F5CE2F" d="m93.96 89.825-5.055 8.779-4.382-2.473 5.58-15.285.454-1.526" />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m93.96 89.825-5.055 8.779-4.382-2.473 5.58-15.285.454-1.526"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M115.304 65.823c1.755 0 3.178-1.4 3.178-3.124 0-1.726-1.423-3.125-3.178-3.125-1.756 0-3.179 1.399-3.179 3.125s1.423 3.124 3.179 3.124"
    />
    <path fill="#F5CE2F" d="m103.832 74.748 8.039-11.615 4.132 2.856-6.978 14.72-.596 1.479" />
    <path
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="m103.832 74.748 8.039-11.615 4.132 2.856-6.978 14.72-.596 1.479"
    />
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.167}
      d="M98.51 77.913c5.273 0 9.546-4.2 9.546-9.382s-4.273-9.383-9.545-9.383-9.546 4.201-9.546 9.383 4.274 9.382 9.546 9.382"
    />
    <path
      fill="#FF0019"
      d="M101.212 57.885c-3.759-1.103-5.774.786-5.774.786s-1.732-.306-3.687.83c-2.21 1.282-2.925 2.748-3.68 4.922-.728 2.1.31 7.06.31 7.06l3.293-.48 1.569-2.826 15.078-3.145s-1.158-5.4-7.109-7.146z"
    />
    <path
      fill="#FF0019"
      d="M98.587 71.374a1.47 1.47 0 0 0 1.482-1.457 1.47 1.47 0 0 0-1.482-1.456 1.47 1.47 0 0 0-1.481 1.456 1.47 1.47 0 0 0 1.481 1.457M104.423 70.226a1.47 1.47 0 0 0 1.482-1.457 1.47 1.47 0 0 0-1.482-1.457c-.818 0-1.482.653-1.482 1.457s.664 1.456 1.482 1.456"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m216.086 90.894-54.251-31.325 39.181-22.624 54.252 31.325z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m233.954 80.577-54.252-31.325 3.449-1.99 54.251 31.324z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m216.085 120.473-54.253-31.32V59.57l54.254 31.321z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m255.271 97.856-39.182 22.62-.001-29.582 39.182-22.62z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m233.954 87.948-.001-7.37 3.448-1.992.001 7.37zM233.954 110.158v-7.371l3.448-1.99v7.37z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m210.801 62.545-37.332-21.556 26.221-15.141 37.333 21.556z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m222.188 55.969-37.332-21.557 3.448-1.99 37.333 21.556z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m210.801 82.64-37.334-21.556.002-20.1 37.332 21.557z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m237.025 67.503-26.224 15.138-.001-20.099 26.224-15.14z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M222.19 62.7v-6.732l3.449-1.991v6.731zM222.19 76.07v-6.732l3.449-1.99v6.73z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m210.173 42.04-24.578-14.19 22.003-12.705 24.578 14.192z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M219.45 36.683 194.872 22.49l3.449-1.99 24.577 14.191z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m232.18 44.216-22.003 12.702-.002-14.88 22.003-12.702z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M219.452 41.868v-5.182l3.448-1.99v5.182zM219.452 51.565v-5.183l3.448-1.991v5.182z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m210.174 56.92-24.581-14.19.002-14.878 24.579 14.188z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m177.603 127.686-.072.404-1.772 1.026-1.783-1.026-.497-2.778 2.28 1.317 1.844 1.067z"
    />
    <path
      fill="#FBDED7"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m140.492 148.787 2.125-1.223 15.971-25.869-2.125 1.223z"
      clipRule="evenodd"
    />
    <path
      fill="#FBDED7"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m187.119 160.374-3.607-2.083v-19.64l-27.05-15.733-15.961 25.869-3.606-2.083c0-13.961 15.971-15.173 15.971-29.134.062 0 29.703 17.257 34.274 19.899v22.905z"
      clipRule="evenodd"
    />
    <path
      fill="#FF0019"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m187.115 160.378 2.125-1.223V136.25l-2.125 1.233v22.905z"
      clipRule="evenodd"
    />
    <path
      fill="#FF0019"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m152.848 117.582 2.124-1.223 34.274 19.899-2.124 1.234-34.274-19.899zM102.156 173.941l2.125-1.223v-19.64l-2.125 1.223z"
      clipRule="evenodd"
    />
    <path
      fill="#FBDED7"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M132.82 168.856v22.905l-3.606-2.083v-19.64l-27.051-15.733v19.64l-3.606-2.083v-22.905c.052 0 29.703 17.256 34.274 19.899z"
      clipRule="evenodd"
    />
    <path
      fill="#FF0019"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m132.816 191.76 2.125-1.223v-22.904l-2.125 1.223z"
      clipRule="evenodd"
    />
    <path
      fill="#FBDED7"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m101.266 148.073 33.683 19.547-1.523.881-33.684-19.558 1.524-.881z"
      clipRule="evenodd"
    />
    <path
      fill="#DEBD8D"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m157.778 113.375-62.04 35.953 34.274 19.899 62.04-35.953z"
      clipRule="evenodd"
    />
    <path
      fill="#FF0019"
      fillRule="evenodd"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M192.055 133.273v2.457l-62.039 35.953v-2.456zM95.738 149.32v2.457l34.274 19.899v-2.457z"
      clipRule="evenodd"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m135.333 137.633 35.37-20.423-24.843-14.343-35.369 20.423z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m135.333 156.676 35.37-20.422-.001-19.043-35.37 20.422zM110.487 142.331l24.845 14.343v-19.043l-24.843-14.342z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="M124.545 150.446v-6.377l-3.267-1.885v6.376z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m110.491 123.288 35.368-20.423-10.728-12.28-35.368 20.423zM135.333 137.633l-24.842-14.345 35.368-20.421v28.688z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.079}
      d="m154.213 126.729-18.88 10.901-8.353-4.822 18.881-10.902zM145.86 102.867l24.845 14.342 10.705-9.836-24.844-14.342zM148.575 140.588l35.37-20.422-13.242-2.955-35.37 20.422zM99.7 127.104l24.844 14.344 10.788-3.817-24.843-14.342z"
    />
    <defs>
      <linearGradient
        id="page-top__image--example_svg__b"
        x1={116.059}
        x2={108.146}
        y1={52.854}
        y2={65.804}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.19} stopColor="#F19A87" />
        <stop offset={0.34} stopColor="#EF9081" />
        <stop offset={0.48} stopColor="#EB8076" />
        <stop offset={0.5} stopColor="#EB7D74" />
      </linearGradient>
      <linearGradient
        id="page-top__image--example_svg__c"
        x1={30.524}
        x2={14.794}
        y1={101.767}
        y2={126.17}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.12} stopColor="#F09986" />
        <stop offset={0.26} stopColor="#ED8A7D" />
        <stop offset={0.36} stopColor="#EB7D74" />
      </linearGradient>
      <clipPath id="page-top__image--example_svg__a">
        <path fill="#fff" d="M150.674.18h-21.726v84.862h21.726z" />
      </clipPath>
    </defs>
  </svg>
);
